import {store} from './store';

export function getStoreObj(id) {
    return store.get(id);
}
